import { useQuery } from '@apollo/client/react';
import { Trans } from 'next-i18next/pages';
import CountUp from 'react-countup';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import { DEFAULT_REGISTERED_USER_COUNT, DEFAULT_REGISTERED_USER_COUNT_PRAXIA } from '@shared/application/constants';
import { GET_WEBSITE_INFORMATION } from '@shared/graphql/operations/website-information';

const COUNT_UP_DURATION = 2;

const TopBar: React.FC = () => {
  const { sourceDomain, isPraxia } = useFlavorFromRoute();
  const defaultValue = isPraxia ? DEFAULT_REGISTERED_USER_COUNT_PRAXIA : DEFAULT_REGISTERED_USER_COUNT;
  const { data } = useQuery(GET_WEBSITE_INFORMATION, {
    fetchPolicy: 'cache-first',
    variables: { sourceDomain },
  });
  const registeredUserCount = data?.getWebsiteInformation?.numberOfUsers ?? defaultValue;

  return (
    <p className='bg-input text-default py-3 text-center text-sm font-normal lg:text-base'>
      <Trans
        components={{
          span: <span className='font-handwriting text-lg font-medium lg:text-lg' />,
          count: <CountUp className='inline-block' end={registeredUserCount} duration={COUNT_UP_DURATION} />,
        }}
        i18nKey='topBar'
        values={{ countTitle: isPraxia ? 'Talente' : 'Pflegekräfte' }}
      />
    </p>
  );
};

export default TopBar;
